import { InfoIcon } from 'icons';
import React from 'react';
import { SkeletonLoader } from './SkeletonLoader';
import { formatSwissAmount } from 'helpers';

interface IBlockProps {
  onClickTooltip: () => void;
  title: string;
  subtitle: string;
  amount: number | string;
  currency?: string;
  loading?: boolean;
  formatted?: boolean;
}

export const WhiteBlock = (props: IBlockProps) => {
  const {
    onClickTooltip,
    title,
    subtitle,
    amount,
    currency,
    loading,
    formatted,
  } = props;
  return (
    <div className="bg-white p-[16px] md:p-[24px] flex flex-col gap-[8px] md:gap-[12px] border-[1px] border-[#E0E1E2] rounded-[16px] md:rounded-[24px] w-full justify-between">
      <div className="flex gap-[8px] md:gap-[17px] items-center font-medium text-[16px] md:text-[20px] text-[#2E435F]">
        {title}
        <button
          onClick={onClickTooltip}
          aria-label={title}
          className="shrink-0 flex items-center"
        >
          <InfoIcon />
        </button>
      </div>
      <div className="flex gap-[6px] items-baseline">
        {loading ? (
          <SkeletonLoader />
        ) : (
          <div className="text-[30px] md:text-[40px] leading-none text-[#2E435F] font-normal tnum">
            {formatted ? formatSwissAmount(amount) : amount}
          </div>
        )}
        {currency && (
          <span className="text-[16px] md:text-[20px] text-[#2E435F] font-normal">
            {currency}
          </span>
        )}
      </div>
      <div className="text-[14px] md:text-[16px] text-[#999AA3] font-medium">
        {subtitle}
      </div>
    </div>
  );
};
